import { Link as RouterLink } from 'react-router-dom';

import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Button from '@mui/material/Button';
import { alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Stack, { StackProps } from '@mui/material/Stack';

import { paths } from 'src/routes/paths';

import { useTranslate } from 'src/locales';
import EmailInboxIcon from 'src/assets/icons/email-inbox-icon';

import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type ConnectEmailPlaceholderProps = StackProps & {
  title?: string;
  description?: string;
};

export default function ConnectEmailPlaceholder({
  title,
  description,
  sx,
  ...other
}: ConnectEmailPlaceholderProps) {
  const { t } = useTranslate();

  return (
    <Card sx={{
      p: 5,
      borderRadius: 2,
      bgcolor: (theme) => alpha(theme.palette.grey[500], 0.04),
      border: (theme) => `dashed 1px ${alpha(theme.palette.grey[500], 0.08)}`,
      ...sx,
    }}>
      <Stack
        spacing={3}
        alignItems="center"
        justifyContent="center"
        sx={{ textAlign: 'center' }}
      >
        <Box sx={{ width: 120, height: 120 }}>
          <EmailInboxIcon />
        </Box>

        <Box>
          <Typography variant="h6" gutterBottom>
            {title || t('account.email-connection.placeholder.title', 'Email Connection Required')}
          </Typography>

          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {description ||
              t(
                'account.email-connection.placeholder.description',
                'This feature requires an email connection to work. Connect your email to access this functionality.'
              )}
          </Typography>
        </Box>

        <Button
          component={RouterLink}
          to={paths.dashboard.account.email}
          variant="contained"
          startIcon={<Iconify icon="mdi:email" />}
          sx={{ mt: 2 }}
        >
          {t('account.email-connection.placeholder.connect_button', 'Connect Email')}
        </Button>
      </Stack>
    </Card>
  );
}